var $ = (jQuery = $);
let locale = window.Shopify.locale;

function OTPReload(base_url) {
  const current_url = new URLSearchParams(window.location.search);
  var activate_account = current_url.get("activate");
  var otp = current_url.get("otp");
  if (otp) {
    var phone = atob(otp);
    var zone = phone.substring(0, 3);
    var subphone = phone.substring(3);
    $(".iti__selected-dial-code")[0].innerText = zone;
    document.getElementById("customer_phone").value = subphone;
    $(".phone-input-div").css("display", "none");
    $(".send_otp_login").css("display", "none");
    $(".errors").css("display", "none");
    $(".note").css("display", "none");
    $(".start_note").css("display", "none");
    $("#continue_login").css("display", "none");
    countdown = setInterval(function () {
      updateButton();
    }, 1000);
    $(".ap-otp-inputs-login").css("display", "flex");
    $(".ap-otp-input-login").css("display", "inline");
    $("#otp_cooldown").css("display", "inline");
    $("#resend_otp").css("display", "inline");
    $("#header_otp").css("display", "block");
    $("#header_signin").css("display", "none");
    $(".sent-opt-text").css("display", "block");
    $("#confirm_login").css("display", "block");
    $("#confirm_login")[0].setAttribute("onclick", "confirmOTP(true)");
    $("#update_email_pw")[0].setAttribute(
      "onclick",
      "updateEmailPw('" + base_url + "',true)"
    );
    var sent_phone = formatPhoneNumber(phone.replace(/ /g, ""));
    document.getElementById("otp-sent-phone").innerText = sent_phone;
    if (activate_account) {
      document.getElementById("confirm_email").value = atob(activate_account);
    }
  } else {
    console.log("pass");
  }

  var checkout_phone = current_url.get("phone");
  if (checkout_phone){
    $("#continue_login").css("display", "none");
    country_code = '+' + checkout_phone.slice(0, 2);
    phone = checkout_phone.slice(2);
    $(".iti__selected-dial-code")[0].innerText = country_code;
    $("#customer_phone").val(phone);
    $("#continue_login").click();
  }
}

const $inpl = $(".ap-otp-input-login");
$inpl.on({
  paste(ev) {
    // Handle Pasting

    const clip = ev.originalEvent.clipboardData.getData("text").trim();
    // Allow numbers only
    if (!/\d{6}/.test(clip)) return ev.preventDefault(); // Invalid. Exit here
    // Split string to Array or characters
    const s = [...clip];
    // Populate inputs. Focus last input.
    $inpl
      .val((i) => s[i])
      .eq(5)
      .focus();
  },
  input(ev) {
    // Handle typing

    const i = $inpl.index(this);
    if (this.value) $inpl.eq(i + 1).focus();
    // console.log(this.value);
  },
  keydown(ev) {
    // Handle Deleting
    const i = $inpl.index(this);
    if (!this.value && ev.key === "Backspace" && i) $inpl.eq(i - 1).focus();
  },
});

let sec = 60;
let countdown = null;

$("#show_password").on("click", function () {
  var x = document.getElementById("customer_password");
  if (x.type === "password") {
    x.type = "text";
  } else {
    x.type = "password";
  }
});

$("#show_password2").on("click", function () {
  var x = document.getElementById("confirm_password");
  if (x.type === "password") {
    x.type = "text";
  } else {
    x.type = "password";
  }
});

$("#show_password3").on("click", function () {
  var x = document.getElementById("reconfirm_password");
  if (x.type === "password") {
    x.type = "text";
  } else {
    x.type = "password";
  }
});

const updateButton = () => {
  const $cooldown = $("#otp_cooldown");
  const $button   = $("#resend_otp");
  $cooldown.show()

  if (locale == "th") {
    $cooldown.html(`ยังไม่ได้รับรหัส OTP? โปรดลองอีกครั้งใน ${sec} วินาที`);
  } else {
    $cooldown.html(`Haven’t got OTP? Try again in ${sec} seconds`);
  }

  $button.hide().prop("disabled", true);

  if (sec === 0) {
    clearInterval(countdown);
    sec = 60;

    // Hiện resend OTP và ẩn cooldown
    $cooldown.hide();
    $button.show().prop("disabled", false);

    return;
  }

  sec--;
};


function sendOTPlogin() {
  if ($("#customer_phone").val().length === 0) {
    alert("Please input your phone");
  } else if ($("#customer_password").val().length === 0) {
    alert("Please input your password");
  } else {
    var phone =
      $(".iti__selected-dial-code")[0].innerText +
      $("#customer_phone").val().replace(/ /g, "");
    var settings = {
      url: "https://apishopify.gqsize.com/supara/send_otp_login",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        phone: phone,
        language: window.Shopify.locale,
      }),
    };
    $.ajax(settings).done(function (response) {
      // console.log(response);
      if (response.code == 200) {
        // updateButton();
        countdown = setInterval(function () {
          updateButton();
        }, 1000);
        $(".login_email").css("display", "none");
        $(".login-input-label").css("display", "none");
        $(".input-row").css("display", "none");
        $(".send_otp_login").css("display", "none");
        $(".errors").css("display", "none");
        $(".ap-otp-inputs-login").css("display", "flex");
        $(".ap-otp-input-login").css("display", "inline");
        $("#otp_cooldown").css("display", "inline");
        $("#resend_otp").css("display", "inline");
        $("#send_otp_login_2").css("display", "inline");
        $(".sent-opt-text").css("display", "block");
        document.getElementById("otp-sent-phone").innerText =
          $("#customer_phone").val();
        // $("#otp_header2").css("display", "block");
        // $("#create_header").css("display", "none");
        // $("#have_account").css("display", "none");
        $("#send_otp_login").css("display", "none");
        // $("#send_otp3").css("display", "inline");
        document.getElementById("customer_email").value = response.email;
        // console.log("ok");
      } else if (response.code == 300) {
        document.querySelector("#submit_login").click();
      } else {
        alert(response.error);
      }
    });
  }
}

function formatPhoneNumber(phoneNumber) {
  phoneNumber = phoneNumber.startsWith("+")
    ? phoneNumber.substring(1)
    : phoneNumber;
  return (
    "+" +
    phoneNumber.slice(0, 2) +
    "-" +
    phoneNumber.slice(2, 5) +
    "-" +
    phoneNumber.slice(5, 8) +
    "-" +
    phoneNumber.slice(8)
  );
}

function disableButtonById(id) {
  let $btn = $(`#${id}`);
  // Disable
  $btn.prop("disabled", true);
  // Thêm icon loading nếu chưa có
  if ($btn.find("i.fa-refresh").length === 0) {
    $btn.prepend('<i class="fa fa-refresh fa-spin"></i> ');
  }
}

function enableButtonById(id) {
  let $btn = $(`#${id}`);
  // Enable lại
  $btn.prop("disabled", false);
  // Xoá icon loading (nếu có)
  $btn.find("i.fa-refresh").remove();
}

document.querySelector("#customer_phone").addEventListener("input", function () {
  this.style.border = "";
  document.querySelector(".input-error-phone-length").style.display = "none";
});

function continueLogin(base_url) {
  const $phoneInput = $("#customer_phone");
  const $errorSpan  = $(".input-error-phone-length");

  let digits = $phoneInput.val().replace(/\D/g, ""); // chỉ giữ số

  if (digits.length < 9) {
    // lỗi: ít hơn 9 số
    $phoneInput.css("border", "1px solid red");
    $errorSpan.show();
    return;
  } else {
    // hợp lệ
    $phoneInput.css("border", "");
    $errorSpan.hide();
  }

  disableButtonById("continue_login");

  let phone =
    $(".iti__selected-dial-code").text() +
    $phoneInput.val().replace(/ /g, "");

  let settings = {
    url: "https://apishopify.gqsize.com/supara/check_customer_account",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      phone: phone,
      language: window.Shopify.locale,
    }),
  };

  $.ajax(settings).done(function (response) {
    if (response.code == 300 || response.code == 400 || response.code == 500 || !response.email) {
      const locale = window.Shopify.locale;
      if (locale != "th") {
        window.location.href =
          "/" + locale + "/account/register?phone=" + phone;
      } else {
        window.location.href = "/account/register?phone=" + phone;
      }
    } else {
      // bắt đầu đếm ngược
      countdown = setInterval(updateButton, 1000);

      $(".ap-otp-inputs-login").css("display", "flex");
      $(".ap-otp-input-login").css("display", "inline");
      $("#resend_otp").css("display", "block");
      $("#header_otp").css("display", "block");
      $("#header_signin").css("display", "none");
      $(".sent-opt-text").css("display", "block");
      $("#confirm_login").css("display", "block");
      $(".phone-input-div").css("display", "none");
      $(".send_otp_login").css("display", "none");
      $(".errors").css("display", "none");
      $(".note").css("display", "none");
      $(".start_note").css("display", "none");
      $("#continue_login").css("display", "none");
      $("#otp_cooldown").css("display", "block");

      // format lại số điện thoại hiển thị
      let sent_phone = $phoneInput.val();
      if (sent_phone[0] != "0") {
        sent_phone = formatPhoneNumber(
          $(".iti__selected-dial-code").text() + $phoneInput.val().replace(/ /g, "")
        );
      }

      $("#otp-sent-phone").text(sent_phone);
      $("#customer_email").val(response.email);
    }
  });
}

function confirmOTP(line_check = false) {
  var otp_code = "";
  if (
    $("#ap-otp-input-login1").val().length > 0 &&
    $("#ap-otp-input-login2").val().length > 0 &&
    $("#ap-otp-input-login3").val().length > 0 &&
    $("#ap-otp-input-login4").val().length > 0 &&
    $("#ap-otp-input-login5").val().length > 0 &&
    $("#ap-otp-input-login6").val().length > 0
  ) {
    disableButtonById("confirm_login")
    otp_code =
      $("#ap-otp-input-login1").val() +
      $("#ap-otp-input-login2").val() +
      $("#ap-otp-input-login3").val() +
      $("#ap-otp-input-login4").val() +
      $("#ap-otp-input-login5").val() +
      $("#ap-otp-input-login6").val();
    // console.log(otp_code);
    var phone =
      $(".iti__selected-dial-code")[0].innerText +
      $("#customer_phone").val().replace(/ /g, "");
    const current_url = new URLSearchParams(window.location.search);
    var checkout_phone = current_url.get("phone");
    if (checkout_phone){
      if(!checkout_phone.includes('+')){
        phone = '+' + checkout_phone;
      } else{
        phone = checkout_phone;
      }
      
    }
    var settings2 = {
      url: "https://apishopify.gqsize.com/supara/verify_otp_login",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        // email: $("#customer_email").val(),
        phone: phone,
        code: otp_code,
      }),
    };
    $.ajax(settings2).done(function (response) {
      // console.log(response);
      if (response.code == 200) {
        if (response.email.includes("/activate")) {
        window.location.href = response.email;
      }
        if (window.location.search.includes("checkout_url")) {
          document.getElementById("customer_password").value = "12345678";
          // document.getElementById("customer_email").value = response.email;
          document.querySelector("#submit_login").click();
        } else if (checkout_phone) {
          ajaxLoginShopify('https://gqsize.com');
        } 
        else if (response.email.includes("@testgq.com") || response.email.includes("dummy")) {
          clearInterval(countdown);
          $(".ap-otp-inputs-login").css("display", "none");
          $(".ap-otp-input-login").css("display", "none");
          $("#otp_cooldown").css("display", "none");
          $("#resend_otp").css("display", "none");
          $("#header_otp").css("display", "none");
          $("#header_signin").css("display", "block");
          $(".sent-opt-text").css("display", "none");
          $("#confirm_login").css("display", "none");
          $("#resend_otp").css("display", "none");
          $(".confirm_email_pw_div").css("display", "block");
          $(".confirm_password-div").css("display", "none");
          // if (line_check) {
          //   $(".confirm_email_pw_note").css("display", "none");
          //   $(".confirm_email-label").css("display", "none");
          //   $("#confirm_email_div").css("display", "none");
          // }
          $("#update_email_pw").css("display", "block");
        } else {
          document.getElementById("customer_password").value = "12345678";
          document.querySelector("#submit_login").click();
        }

        // if (window.location.search.includes("checkout_url")) {
        //   document.getElementById("customer_password").value = "12345678";
        //   document.getElementById("customer_email").value = response.email;
        //   document.querySelector("#submit_login").click();
        // } else {
        //   email = $("#confirm_email").val();
        //   if (email.includes("/activate")) {
        //     window.location.href = email;
        //   } else {
        //     clearInterval(countdown);
        //     $(".ap-otp-inputs-login").css("display", "none");
        //     $(".ap-otp-input-login").css("display", "none");
        //     $("#otp_cooldown").css("display", "none");
        //     $("#resend_otp").css("display", "none");
        //     $("#header_otp").css("display", "none");
        //     $("#header_signin").css("display", "block");
        //     $(".sent-opt-text").css("display", "none");
        //     $("#confirm_login").css("display", "none");
        //     $("#resend_otp").css("display", "none");
        //     $(".confirm_email_pw_div").css("display", "block");
        //     if (line_check) {
        //       $(".confirm_email_pw_note").css("display", "none");
        //       $(".confirm_email-label").css("display", "none");
        //       $("#confirm_email_div").css("display", "none");
        //     }
        //     $("#update_email_pw").css("display", "block");
        //   }
        // }
      } else {
        alert(response.error);
        enableButtonById("confirm_login")
      }
    });
  } else {
    alert("Please input OTP code");
    enableButtonById("confirm_login")
  }
}

function resendOTP() {
  // disableButtonById("resend_otp")
  var phone =
    $(".iti__selected-dial-code")[0].innerText +
    $("#customer_phone").val().replace(/ /g, "");
  var settings = {
    url: "https://apishopify.gqsize.com/supara/resend_otp",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      phone: phone,
      language: window.Shopify.locale,
    }),
  };
  $.ajax(settings).done(function (response) {
    if (response.code == 200) {
      countdown = setInterval(function () {
        updateButton();
      }, 1000);
      $("#ap-otp-input-login1").val('');
      $("#ap-otp-input-login2").val('');
      $("#ap-otp-input-login3").val('');
      $("#ap-otp-input-login4").val('');
      $("#ap-otp-input-login5").val('');
      $("#ap-otp-input-login6").val('');
      $("#resend_otp").css("display", "none");
    } else {
      alert(response.error);
      // enableButtonById("resend_otp")
    }
  });
}

function updateEmailPw(base_url, line_check = false) {
  if (!line_check) {
    if ($("#confirm_email").val().length === 0) {
      alert("Please input your email");
    }
    var email = $("#confirm_email").val();
  } else {
    var email = false;
  }
  // if ($("#confirm_password").val().length === 0) {
  //   alert("Please input your password");
  // } else if ($("#reconfirm_password").val().length === 0) {
  //   alert("Please input your confirm password");
  // } else if ($("#confirm_password").val() != $("#reconfirm_password").val()) {
  //   alert("Password and confirm password not match.");
  // } else if ($("#confirm_password").val().length < 8) {
  //   alert("Password must be at least 8 characters.");
  // } else {
  var phone =
    $(".iti__selected-dial-code")[0].innerText +
    $("#customer_phone").val().replace(/ /g, "");
  if (email){
     var settings = {
    url: "https://apishopify.gqsize.com/supara/update_email_pw",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      phone: phone,
      email: email,
      password: "12345678",
    }),
  };
  $.ajax(settings).done(function (response) {
    if (response.code == 200) {
      document.getElementById("customer_email").value = response.email;
      document.getElementById("customer_password").value = "12345678";
      // var settings = {
      //   url: "https://dev.api.backend.gw.int.suparagroup.com/gq-connect/webhooks/shopify/existing_customer",
      //   method: "POST",
      //   timeout: 0,
      //   headers: {
      //     "Content-Type": "application/json",
      //     "api-key": "E4E74715-56CE-447A-8B2F-8BBBE7885F22",
      //     client: "shopify",
      //   },
      //   data: JSON.stringify({
      //     phone: phone,
      //     update_password: true,
      //   }),
      // };

      // $.ajax(settings).done(function (response) {
      //   console.log(response);
      // });
      ajaxLoginShopify(base_url);
    } else {
      alert(response.error);
    }
  });
  }
  // }
}

function sendOTPlogin2(base_url) {
  var phone =
    $(".iti__selected-dial-code")[0].innerText +
    $("#customer_phone").val().replace(/ /g, "");
  var settings = {
    url: "https://apishopify.gqsize.com/supara/send_otp_login",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      phone: phone,
      language: window.Shopify.locale,
    }),
  };
  $.ajax(settings).done(function (response) {
    if (response.code == 200) {
      document.getElementById("customer_email").value = response.email;
    } else if (response.code == 300) {
      document.querySelector("#submit_login").click();
    } else {
      alert(response.error);
    }
  });
  ajaxLoginShopify(base_url);
}

function ajaxLoginShopify(base_url) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    customer: {
      email: $("#customer_email").val(),
      password: "12345678",
    },
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  fetch(base_url + "/account/login" + window.location.search, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      const current_url = new URLSearchParams(window.location.search);
      var checkout_phone = current_url.get("phone");
      if(checkout_phone){
        window.history.back();
      }
      else if (result.includes("tier-reward")) {
        const locale = window.Shopify.locale;
        if (locale != "th") {
          window.location.href = "/" + locale + "/pages/membership-homepage";
        } else {
          window.location.href = "/pages/membership-homepage";
        }
      } else {
        document.querySelector("#submit_login").click();
      }
    })
    .catch((error) => console.log("error", error));
}

// formElement.addEventListener("keydown", function (e) {
//   debugger;
//   if (e.key === "Enter") {
//     console.log("Enter");
//   }
// });

$(document).keypress(function(event){
    if (event.which == 13) {
        event.preventDefault();
        var btn = $("div.wide-action button:visible:not(#resend_otp)").first();
        btn.click();
    }
});

